import React from 'react';
import { formatToMoney } from "../../utils/common";

const ItemRender = (data) => {

    const isZero = data.stock <= 0;

    const cssZero = isZero ? 'product-stock zero-stock' : 'product-stock';

    return <div className="d-flex space-between">
        <div>
            <div className="product-name"><b>{data.internalCode}</b>-{data.name}</div>
            <div className="product-desciption"><small className='text-muted'>Categoria: </small>{data.family} <small className='text-muted'>Marca: </small>{data.presentation}</div>
        </div>  
        <div className="text-right">
            <div className="product-price">{formatToMoney(data.price)}</div>
            <div className={cssZero}><small className='text-muted'>Disponible:</small> {data.stock}/{data.disponible}</div>
        </div>    
    </div>
}

export default ItemRender;